import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import { Box, Button, Heading, Stack, Text } from "@chakra-ui/react"


import {
    getFormattedDistance,
    getFormattedDuration,
} from "../utilities/formattingHelper"
import {
    getDistanceForJourneys,
    getDurationForJourneys,
    getNoOfCountriesFromJourneys,
    getNoOfDomesticJourneys,
    getNoOfInternationalJourneys,
    getOverviewForJourneys,
} from "../utilities/journeyAnalysisHelper"

import ViewInsightsButton from "./ui/ViewInsightsButton"
import { InsightsPanelHeading, InsightsPanelStack, InsightsPanelText } from "./insights/InsightsPanelComponentsGroup"


export default function JourneyOverview({ journeysToDisplay }) {

    const { journeys } = useSelector((state) => state.journeys)

    const [dataToDisplay, setDataToDisplay] = useState(undefined)

    useEffect(() => {
        if (!journeys)
            return

        setDataToDisplay(getOverviewForJourneys(journeysToDisplay))
    }, [journeys])

    if (!dataToDisplay) {
        return (<></>)
    }

    return (
        <>
            <InsightsPanelStack>
                <InsightsPanelHeading>
                    {dataToDisplay.noOfJourneys}
                    {dataToDisplay.noOfJourneys !== 1 ? ' journeys' : ' journey'} over {getFormattedDistance(dataToDisplay.totalDistance, 'km')}km
                </InsightsPanelHeading>

                <InsightsPanelText>
                    Average distance: <strong>{getFormattedDistance(dataToDisplay.averageDistance, 'km')}km</strong>
                </InsightsPanelText>

                <InsightsPanelText>
                    <strong>{getFormattedDuration(dataToDisplay.totalDuration)}</strong> total duration
                </InsightsPanelText>
                
                <InsightsPanelText>
                    Average duration: <strong>{getFormattedDuration(dataToDisplay.averageDuration.toFixed(0))}</strong>
                </InsightsPanelText>

                <InsightsPanelText>
                    An aggregate of <strong>{dataToDisplay.fullyFormattedDuration}</strong>
                </InsightsPanelText>

                <InsightsPanelText>
                    A total of <strong>{dataToDisplay.noOfStationsVisited}</strong>
                    {dataToDisplay.noOfStationsVisited !== 1 ? ' stations' : ' station'} visited
                </InsightsPanelText>

                <InsightsPanelText>
                    <strong>{dataToDisplay.noOfCountriesVisitedByRail}</strong>
                    {dataToDisplay.noOfCountriesVisitedByRail !== 1 ? ' countries' : ' country'} travelled to by rail
                </InsightsPanelText>

            </InsightsPanelStack>



            <ViewInsightsButton text='View more insights' isDisabled={journeys.length === 0} />

            {journeys.length !== journeysToDisplay.length && (
                <Text align='center' as='i'>
                    Overview is based on currently applied filters
                </Text>
            )}
        </>
    )
}
